export default __webpack_public_path__ + "static/media/7_JuggySwap.733ef903.webp";